import type { CelProgram, TemplateAutocomplete, TypedOnboardingData } from '@onefootprint/request-types/dashboard';

export const getDefaultValues = (programs: CelProgram[]) => {
  if (!programs || programs.length === 0) {
    return [{ dataKey: '', expression: '' }] as { dataKey: string; expression: string }[];
  }
  return programs.map(program => ({
    dataKey: program.dataKey,
    expression: program.expression,
  }));
};

// Expressions execute sequentially, so each one can reference `data.<key>` values assigned by the
// expressions before it. The base autocomplete context only covers tokens available before the node
// runs, so we synthesize the preceding programs' data keys here, typed from the live check.
export const getAutocompleteWithPriorDataKeys = (
  base: TemplateAutocomplete | undefined,
  priorDataKeys: string[],
  typesByDataKey?: Map<string, TypedOnboardingData>,
): TemplateAutocomplete | undefined => {
  // Prior keys alone would read as the whole list, so let the editor say "Loading..." instead.
  if (!base) return undefined;
  const baseTokens = base.tokens;
  const seen = new Set(baseTokens.map(t => t.token));
  const priorTokens: TemplateAutocomplete['tokens'] = [];
  for (const key of priorDataKeys) {
    if (!key.trim()) continue;
    const token = `data.${key}`;
    if (seen.has(token)) continue;
    seen.add(token);
    // A key the backend hasn't typed yet stays unknown rather than guessing.
    const dataType = typesByDataKey?.get(key)?.dataType ?? ['unknown'];
    priorTokens.push({ display: token, token, dataType });
  }
  return { tokens: [...baseTokens, ...priorTokens] };
};
